import { useState } from 'react';
import { FIX_SENTENCE_START_TIME } from '../utils/const';

/**
 * センテンスの時間
 */
type SentenceTime = {
  // 開始時間
  startTime: number;
  // 終了時間
  endTime: number;
};

type Times = {
  // 英語
  english: SentenceTime;
  // 日本語
  japanese: SentenceTime | null;
};

type UseTrainingHopSentenceValue = {
  // 英語文が見えるかどうか
  isEnglishVisible: boolean;
  // isEnglishVisibleの更新メソッド
  updateIsEnglishVisible: (currentTime: number) => void;
  // 日本語文が見えるかどうか
  isJapaneseVisible: boolean;
  // isJapaneseVisibleの更新メソッド
  updateIsJapaneseVisible: (currentTime: number) => void;
};

const UseTrainingHopSentence = (times: Times): UseTrainingHopSentenceValue => {
  // 英語文が見えるかどうか
  const [isEnglishVisible, setIsEnglishVisible] = useState<boolean>(false);
  // 日本語文が見えるかどうか
  const [isJapaneseVisible, setIsJapaneseVisible] = useState<boolean>(false);

  /**
   * isEnglishVisibleの更新処理
   * @param currentTime 再生時間
   */
  const updateIsEnglishVisible = (currentTime: number) => {
    // Safari(iOS、macOS)で、センテンスが点滅しないように、開始時間を早める
    const startTime = times.english.startTime - FIX_SENTENCE_START_TIME;

    const endTime = times.japanese
      ? times.japanese.endTime
      : times.english.endTime;
    const isVisible = startTime <= currentTime && currentTime <= endTime;
    setIsEnglishVisible(isVisible);
  };

  /**
   * isJapaneseVisibleの更新処理
   * @param currentTime 再生時間
   */
  const updateIsJapaneseVisible = (currentTime: number) => {
    if (!times.japanese) {
      return;
    }

    // Safari(iOS、macOS)で、センテンスが点滅しないように、開始時間を早める
    const startTime = times.japanese.startTime - FIX_SENTENCE_START_TIME;

    const isVisible =
      startTime <= currentTime && currentTime <= times.japanese.endTime;
    setIsJapaneseVisible(isVisible);
  };

  return {
    isEnglishVisible,
    updateIsEnglishVisible,
    isJapaneseVisible,
    updateIsJapaneseVisible,
  };
};

export default UseTrainingHopSentence;
